import { Route } from 'vue-router';
import { Module } from 'vuex';
import { getUser } from '@/auth/auth';
import { User } from '@/models/auth';
import {
  AUTH_SET_LOGIN_RETURN_PATH,
  AUTH_USER_LOGIN_PENDING,
  AUTH_USER_LOGIN_SUCCESS,
  AUTH_USER_LOGIN_FAILURE,
  AUTH_USER_LOGOUT_CLEANUP
} from '../mutation-types';
import { RootState } from '../types';

interface AuthState {
  loginReturnPath: Route | null;
  loading: boolean;
  error: string | null;
  token: string | null;
  user: User | null;
}

const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: {
    loginReturnPath: null,
    loading: false,
    error: null,
    token: null,
    user: null
  },
  getters: {
    loginReturnPath: state => state.loginReturnPath,
    auth: state => state,
    authToken: state => state.token,
    user: state => state.user,
    userFullName: state =>
      state.user
        ? `${state.user.name} ${state.user.family_name}`
        : 'Unkown user',
    userSecurityRole: state =>
      state.user && state.user.securityRole ? state.user.securityRole : null
  },
  actions: {
    // Auth
    setLoginReturnPath({ commit }, path) {
      const { name, params, query, hash } = path;
      commit(AUTH_SET_LOGIN_RETURN_PATH, { name, params, query, hash });
    },
    clearLoginReturnPath({ commit }) {
      commit(AUTH_SET_LOGIN_RETURN_PATH, null);
    },
    async logIn({ commit }) {
      commit(AUTH_USER_LOGIN_PENDING);
      try {
        const tokenUser = await getUser();
        commit(AUTH_USER_LOGIN_SUCCESS, tokenUser);
      } catch (e) {
        commit(AUTH_USER_LOGIN_FAILURE, e);
      }
    },
    logInFailure({ commit }, error) {
      commit(AUTH_USER_LOGIN_FAILURE, error);
    },
    logOut({ commit }) {
      commit(AUTH_USER_LOGOUT_CLEANUP);
    }
  },
  mutations: {
    [AUTH_SET_LOGIN_RETURN_PATH](state, path) {
      state.loginReturnPath = path;
    },
    // Auth
    [AUTH_USER_LOGIN_PENDING](state) {
      state.loading = true;
      state.error = null;
    },
    [AUTH_USER_LOGIN_SUCCESS](state, payload) {
      state.loading = false;
      state.user = payload;
    },
    [AUTH_USER_LOGIN_FAILURE](state, error) {
      state.loading = false;
      state.error = error;
    },
    [AUTH_USER_LOGOUT_CLEANUP](state) {
      state.user = null;
    }
  }
};

export default auth;
